export type LiveTvCategory = 'haber' | 'spor'

export type LiveTvSourceType = 'channel' | 'video'

export type LiveTvChannel = {
  key: string
  title: string
  slug: string
  /** channel = YouTube kanal UC… · video = sabit video id */
  type: LiveTvSourceType
  /** type=channel → kanal ID · type=video → video ID */
  id: string
  category: LiveTvCategory
  /** Varsa @handle (çözümleme yedeği) */
  handle?: string
  /** Sabit logo (unavatar başarısız olursa) */
  logoUrl?: string
  color: string
}

const C = {
  red: '#C02727',
  crimson: '#B71C1C',
  orange: '#E65100',
  amber: '#F7A600',
  gold: '#F9A825',
  green: '#1B5E20',
  teal: '#00695C',
  blue: '#1565C0',
  navy: '#0A1F44',
  indigo: '#1A237E',
  purple: '#6C1D5F',
  pink: '#AD1457',
  black: '#111111',
  gray: '#37474F',
} as const

/**
 * Haber + spor aday kataloğu.
 * Listede yalnızca YouTube /live’da o an yayında olanlar gösterilir.
 */
export const LIVE_TV_CHANNELS: LiveTvChannel[] = [
  // Haber
  {
    key: '24tv',
    title: '24 TV',
    slug: '24tv',
    type: 'channel',
    id: 'UCN7VYCsI4Lx1-J4_BtjoWUA',
    handle: 'YirmidortTV',
    logoUrl:
      'https://yt3.googleusercontent.com/gWxG3v8R74BMB5GWgX0v9HoFKmKLtTl533CgLfoHcRfRXQPTTcAYgvrnplkwqOmq4GZnmOLkbw=s240-c-k-c0x00ffffff-no-rj',
    category: 'haber',
    color: C.red,
  },
  {
    key: 'ahaber',
    title: 'A Haber',
    slug: 'ahaber',
    type: 'channel',
    id: 'UCKQhfw-lzz0uKnE1fY1PsAA',
    handle: 'Ahaber',
    logoUrl:
      'https://yt3.googleusercontent.com/iGfNwuCajXhAmxigBNcV9l5lB30dhtq7KcMsabzVB-9op67lUHGBa-CfMQKlJ94oC_9gc3Ti2A=s240-c-k-c0x00ffffff-no-rj',
    category: 'haber',
    color: C.crimson,
  },
  {
    key: 'apara',
    title: 'A Para',
    slug: 'apara',
    type: 'channel',
    id: 'UCzrGg6iyRDuUSnO0cQ5oLcA',
    handle: 'apara',
    logoUrl:
      'https://yt3.googleusercontent.com/kVN8qF1qB-cXhjjKrwdWJ3IGOdZAy_nXBCtBEHu7xs2Wsqu_0nWyKX1hIBPxuGC9HkCPsAR6=s240-c-k-c0x00ffffff-no-rj',
    category: 'haber',
    color: C.amber,
  },
  {
    key: 'akit-tv',
    title: 'Akit TV',
    slug: 'akit-tv',
    type: 'channel',
    id: 'UCbaLyHJp6S9Lsj6oT9aJsQw',
    handle: 'akittv',
    logoUrl:
      'https://yt3.googleusercontent.com/u7W_zTezWfYi6zwkO9et9XLITXUXsb636AhT36NuqVDoutG08Rdy9uoNmchMcuC7wNbjP89oBQ=s240-c-k-c0x00ffffff-no-rj',
    category: 'haber',
    color: C.gray,
  },
  {
    key: 'benguturk',
    title: 'Bengütürk',
    slug: 'benguturk',
    type: 'channel',
    id: 'UChNgvcVZ_ggDdZ0zCcuuzFw',
    handle: 'tvbenguturk',
    logoUrl:
      'https://yt3.googleusercontent.com/xfEZjkOt4ZAltabZ4Of6niPktZJ9uJQI7C3T8pjEXzQBKgY1rkgxzyBoXUQlOjhtGePCYcq0MW4=s240-c-k-c0x00ffffff-no-rj',
    category: 'haber',
    color: C.orange,
  },
  {
    key: 'bloomberght',
    title: 'Bloomberg HT',
    slug: 'bloomberght',
    type: 'channel',
    id: 'UCApLxl6oYQafxvykuoC2uxQ',
    handle: 'bloomberght',
    logoUrl:
      'https://yt3.googleusercontent.com/ytc/AIdro_kYr_pJ26fMpoQPKgJEACBiddx9WO4CV4akUE8yBzhrHMg=s240-c-k-c0x00ffffff-no-rj',
    category: 'haber',
    color: C.black,
  },
  {
    key: 'business-channel-turk',
    title: 'Business Channel Türk',
    slug: 'business-channel-turk',
    type: 'channel',
    id: 'UCLPc5pYOl2clEkCA82Sfb0Q',
    handle: 'BusinessChannelTVV',
    logoUrl:
      'https://yt3.googleusercontent.com/zP1Fik1Cu0Cx7gU0ZR5vhsrzundUZnK0j1fXe38YKsd-R5ptibDxs5hcf0FTT8igp83uhKSG8w=s240-c-k-c0x00ffffff-no-rj',
    category: 'haber',
    color: C.navy,
  },
  {
    key: 'cnbc-e',
    title: 'CNBC-e',
    slug: 'cnbc-e',
    type: 'channel',
    id: 'UCaO-M1dXacMwtyg0Pvovk4w',
    handle: 'cnbce',
    logoUrl:
      'https://yt3.googleusercontent.com/P0jy3MGfkfshxuWzmVaGgrl9ZeuuHCYzSbH3vxvYwxUmWuJZ_nGkuu2RVcbab6yQFe8In0EIZw=s240-c-k-c0x00ffffff-no-rj',
    category: 'haber',
    color: C.navy,
  },
  {
    key: 'cnnturk',
    title: 'CNN Türk',
    slug: 'cnnturk',
    type: 'channel',
    id: 'UCV6zcRug6Hqp1UX_FdyUeBg',
    handle: 'cnnturk',
    logoUrl:
      'https://yt3.googleusercontent.com/H6Fh64z_Vb9AYevqCPwgeyRAyd4mye6fqU2HN5Jj1RWtrtK5lbU3B2Nkxc_nJfpN_WpI5_flfBk=s240-c-k-c0x00ffffff-no-rj',
    category: 'haber',
    color: C.crimson,
  },
  {
    key: 'dw-turkce',
    title: 'DW Türkçe',
    slug: 'dw-turkce',
    type: 'channel',
    id: 'UCpi_jv70749NkAmkdugyiPQ',
    handle: 'dwturkce',
    logoUrl:
      'https://yt3.googleusercontent.com/NrwseNOvHHHnEig3PeRgmhUvTyPo75bv8Gr01HUN2jk8ge2O8VuMJ_4gQk9QmcYDa-Y0MAlG=s240-c-k-c0x00ffffff-no-rj',
    category: 'haber',
    color: C.blue,
  },
  {
    key: 'ekoturk',
    title: 'Ekotürk',
    slug: 'ekoturk',
    type: 'channel',
    id: 'UCAGVKxpAKwXMWdmcHbrvcwQ',
    handle: 'EKOTURKTV',
    logoUrl:
      'https://yt3.googleusercontent.com/nRcWKlah9W0Sm24UlNIgtmyhyJZZ6LTdfc9J-pUOLH-4F50zzBysb1vPJbIkd_B7PrmTH1K5R88=s240-c-k-c0x00ffffff-no-rj',
    category: 'haber',
    color: C.blue,
  },
  {
    key: 'euronews-turkce',
    title: 'euronews Türkçe',
    slug: 'euronews-turkce',
    type: 'channel',
    id: 'UC7nLr-rPOKYhRE4wRZoLxkg',
    handle: 'euronewstr',
    logoUrl:
      'https://yt3.googleusercontent.com/gp_fbs7hKvoe8LwYuX7xqPHShoJHOUI6dLkT5wPB5ZYMsOHxvGxiC9Ux9km35PC6VHFu4NAPUw=s240-c-k-c0x00ffffff-no-rj',
    category: 'haber',
    color: C.navy,
  },
  {
    key: 'flash-haber',
    title: 'Flash Haber',
    slug: 'flash-haber',
    type: 'channel',
    id: 'UCNcjCb2RnA3eMMhTZSxZu3A',
    handle: 'FlashHaberTV',
    logoUrl:
      'https://yt3.googleusercontent.com/9Hqnz42k04uQF15nx0Dk9sh6JtLWtVtzMIxp_W4TuxtUB2cq2Q515dnD095_muJUBjUhtRz70sA=s240-c-k-c0x00ffffff-no-rj',
    category: 'haber',
    color: C.orange,
  },
  {
    key: 'haberglobal',
    title: 'Haber Global',
    slug: 'haberglobal',
    type: 'channel',
    id: 'UCtc-a9ZUIg0_5HpsPxEO7Qg',
    handle: 'haberglobal',
    logoUrl:
      'https://yt3.googleusercontent.com/jSWgyqCsy8hQ9sIgccNhbUht_koPL8VYqZkirL7GLrj8QwOYBhkIkVEjq9OTEAM3mOlSIymwZw=s240-c-k-c0x00ffffff-no-rj',
    category: 'haber',
    color: C.blue,
  },
  {
    key: 'haberturk',
    title: 'Habertürk',
    slug: 'haberturk',
    type: 'channel',
    id: 'UCn6dNfiRE_Xunu7iMyvD7AA',
    handle: 'haberturktv',
    logoUrl:
      'https://yt3.googleusercontent.com/SqaSrx9HvlbnpXqfrsyqJOpL3uHHi3GQ3htT3gPdP3S8yebiy4iVPrZ4Ai1wQnNoHv7aUBLIeEE=s240-c-k-c0x00ffffff-no-rj',
    category: 'haber',
    color: C.amber,
  },
  {
    key: 'halktv',
    title: 'Halk TV',
    slug: 'halktv',
    type: 'channel',
    id: 'UCf_ResXZzE-o18zACUEmyvQ',
    handle: 'Halktvkanali',
    logoUrl:
      'https://yt3.googleusercontent.com/u8lIyigiEuofBWzGVRVJ_WOOdXp6cPTt9-02Kp8lG4XgMHXx0ZB_lwNINw4sLJaAk6ej35ueeA=s240-c-k-c0x00ffffff-no-rj',
    category: 'haber',
    color: C.crimson,
  },
  {
    key: 'krttv',
    title: 'KRT TV',
    slug: 'krttv',
    type: 'channel',
    id: 'UCVKWwHoLwUMMa80cu_1uapA',
    handle: 'krtcanli',
    logoUrl:
      'https://yt3.googleusercontent.com/5-coJeWxxU9a8VNXv-X7fXpclUFJk2a4KXLdOUSADNIRfJDM2Shmc1eybhHL6nS_nYz4_yKFWVk=s240-c-k-c0x00ffffff-no-rj',
    category: 'haber',
    color: C.pink,
  },
  {
    key: 'lider-haber',
    title: 'Lider Haber',
    slug: 'lider-haber',
    type: 'channel',
    id: 'UCgH3Vo5DVMsrbDSUoSecm0Q',
    handle: 'liderhabertv',
    logoUrl:
      'https://yt3.googleusercontent.com/i6FBCAwWvdgxa8_WZxeTZ8g7BIghCjkgpKpdkffRX_chxLVU_MvU1PT2Soch_hrUMuq6j8iJ3w=s240-c-k-c0x00ffffff-no-rj',
    category: 'haber',
    color: C.red,
  },
  {
    key: 'now-haber',
    title: 'NOW Haber',
    slug: 'now-haber',
    type: 'channel',
    id: 'UCi3YX2RoncmqT9GmmoS36cw',
    handle: 'NOWHaber',
    logoUrl:
      'https://yt3.googleusercontent.com/ytc/AIdro_kFgGxM3aDBe2sjrvElqL8HYiQIcKxyeF6QF8z_b6y2RlZHraJr0i89ffz9uvpBtF7hrQ=s240-c-k-c0x00ffffff-no-rj',
    category: 'haber',
    color: C.orange,
  },
  {
    key: 'ntv',
    title: 'NTV',
    slug: 'ntv',
    type: 'channel',
    id: 'UC9TDTjbOjFB9jADmPhSAPsw',
    handle: 'NTV',
    logoUrl:
      'https://yt3.googleusercontent.com/PUOG4AugF5attdcdO6O1sOIkFykoEJBTKF0d6hLlzAj_VCPD3MUyMOZTiwyfs-NbqL7qLNJuRw=s240-c-k-c0x00ffffff-no-rj',
    category: 'haber',
    color: C.red,
  },
  {
    key: 'sozcu-tv',
    title: 'Sözcü TV',
    slug: 'sozcu-tv',
    type: 'channel',
    id: 'UCOulx_rep5O4i9y6AyDqVvw',
    handle: 'Sozcutelevizyonu',
    logoUrl:
      'https://yt3.googleusercontent.com/_HznzWrS2cMaKa8Jp_uZhzWt7-25ijH7pZlXq45D9vapjDu5DRsh9uu0vfa2NH2Iayw5yxhaDQ=s240-c-k-c0x00ffffff-no-rj',
    category: 'haber',
    color: C.red,
  },
  {
    key: 'tele1',
    title: 'TELE1',
    slug: 'tele1',
    type: 'channel',
    id: 'UCoHnRpOS5rL62jTmSDO5Npw',
    handle: 'tele1comtr',
    logoUrl:
      'https://yt3.googleusercontent.com/W3z9GW0MJQfPN-a-usbsNpF9aFiEP8VU4Qx808NCB0ARD4U0G96MtFFH7peDDgRLfpjKherWPek=s240-c-k-c0x00ffffff-no-rj',
    category: 'haber',
    color: C.crimson,
  },
  {
    key: 'tgrt-haber',
    title: 'TGRT Haber',
    slug: 'tgrt-haber',
    type: 'channel',
    id: 'UCzgrZ-CndOoylh2_e72nSBQ',
    handle: 'tgrthaber',
    logoUrl:
      'https://yt3.googleusercontent.com/ytc/AIdro_mLAxlfYMg4fHPVZA80ly_sjryTgQGUDe-TeH4-j3zrkw=s240-c-k-c0x00ffffff-no-rj',
    category: 'haber',
    color: C.blue,
  },
  {
    key: 'trthaber',
    title: 'TRT Haber',
    slug: 'trthaber',
    type: 'channel',
    id: 'UCBgTP2LOFVPmq15W-RH-WXA',
    handle: 'trthaber',
    logoUrl:
      'https://yt3.googleusercontent.com/X-b7tJvjfBMDHCAafwyNV89qJ_FlzlXChymSisVsncnPpgOLLHknR6n1wtm8huk0SJz3KhNRTQ=s240-c-k-c0x00ffffff-no-rj',
    category: 'haber',
    color: C.blue,
  },
  {
    key: 'trt-world',
    title: 'TRT World',
    slug: 'trt-world',
    type: 'channel',
    id: 'UC7fWeaHhqgM4Ry-RMpM2YYw',
    handle: 'trtworld',
    logoUrl:
      'https://yt3.googleusercontent.com/luLQWmGFG4iDC1U_2JlzZ1mquci_sUdfZfFl4eWgBkDpW6tvZT0MEA4c4JebJdi9hCo518q1=s240-c-k-c0x00ffffff-no-rj',
    category: 'haber',
    color: C.blue,
  },
  {
    key: 'turkiye-gazetesi',
    title: 'Türkiye Gazetesi',
    slug: 'turkiye-gazetesi',
    type: 'channel',
    id: 'UCJET1tOY_ogUK-J9wqVVJYg',
    handle: 'TurkiyeGazetesi',
    logoUrl:
      'https://yt3.googleusercontent.com/elvUL-KOngcPeI_rBnFZjRv4I7JxTGYei5jJ6j8PMvB9zeBU6KGXtF-fFFAhlFrHlTVuHYgXEw=s240-c-k-c0x00ffffff-no-rj',
    category: 'haber',
    color: C.red,
  },
  {
    key: 'tv100',
    title: 'tv100',
    slug: 'tv100',
    type: 'channel',
    id: 'UCndsdUW_oPLqpQJY9J8oIRg',
    handle: 'tv100',
    logoUrl:
      'https://yt3.googleusercontent.com/WXUY70sBchgInLUF54mdesskQBEiBZVi6Pxg96vgd7hg5NjvWx9K9E7ezbwmP4IhH5M6gj9h_JU=s240-c-k-c0x00ffffff-no-rj',
    category: 'haber',
    color: C.indigo,
  },
  {
    key: 'tv360',
    title: 'TV360',
    slug: 'tv360',
    type: 'channel',
    id: 'UCfqRQZ40fwEdaDWPuR7tvcw',
    handle: 'tv360',
    logoUrl:
      'https://yt3.googleusercontent.com/ytc/AIdro_kZVDU4urtdSMj-Ubv76W22JRs-GiLQN1UA29bzu4aa6uk=s240-c-k-c0x00ffffff-no-rj',
    category: 'haber',
    color: C.blue,
  },
  {
    key: 'tvnet',
    title: 'TVNET',
    slug: 'tvnet',
    type: 'channel',
    id: 'UC8rh34IlJTN0lDZlTwzWzjg',
    handle: 'TVNET',
    logoUrl:
      'https://yt3.googleusercontent.com/WJm8IMexX9Atd0eOkmHFXagUieCC43mZO1B-TQAhBYm8iR4H5do0Go_kYWz_g-bSYxx6yXZPycI=s240-c-k-c0x00ffffff-no-rj',
    category: 'haber',
    color: C.green,
  },
  {
    key: 'ulusal-kanal',
    title: 'Ulusal Kanal',
    slug: 'ulusal-kanal',
    type: 'channel',
    id: 'UC6T0L26KS1NHMPbTwI1L4Eg',
    handle: 'ulusalkanalTV',
    logoUrl:
      'https://yt3.googleusercontent.com/EDcyi5hZ1hX_gPI-QQGKqcBwsQlvuuD3hz-N8utLebWL0uLE9pqTzpS8jXW7J-lsUmEICR5K3w=s240-c-k-c0x00ffffff-no-rj',
    category: 'haber',
    color: C.crimson,
  },
  {
    key: 'ulke-tv',
    title: 'Ülke TV',
    slug: 'ulke-tv',
    type: 'channel',
    id: 'UCi65FGbYYj-OzJm2luB_fNQ',
    handle: 'ulketv',
    logoUrl:
      'https://yt3.googleusercontent.com/PU7e5TS6A8xnGNoOEdyCLz1GQAPJopPZN9_fZmftBx8x4Tn-oEcgdL9FI3GH_uAGKAqJSb8m=s240-c-k-c0x00ffffff-no-rj',
    category: 'haber',
    color: C.orange,
  },
  {
    key: 'voa-turkce',
    title: 'VOA Türkçe',
    slug: 'voa-turkce',
    type: 'channel',
    id: 'UCb9LU12nWcmrXu3m3Dh0nEg',
    handle: 'voaturkce',
    logoUrl:
      'https://yt3.googleusercontent.com/XES4bjA7nW5z9sBHe1W2VAIkNZ8Ltkjl1eUVR3Nwfb8jqJhyQgnJXuJiEQh7OC1w7Q5ZmyLqc5Q=s240-c-k-c0x00ffffff-no-rj',
    category: 'haber',
    color: C.blue,
  },

  // Spor
  {
    key: 'aspor',
    title: 'A Spor',
    slug: 'aspor',
    type: 'channel',
    id: 'UCJElRTCNEmLemgirqvsW63Q',
    handle: 'ASpor',
    logoUrl:
      'https://yt3.googleusercontent.com/43xh3uEvLl7kAKca-zFauATzT3spixqjb9v-cYBVxBLzbcbVj42iV3Msbpd5zXwN_w7jXdnzFq8=s240-c-k-c0x00ffffff-no-rj',
    category: 'spor',
    color: C.crimson,
  },
  {
    key: 'bein-sports-haber',
    title: 'beIN Sports Haber',
    slug: 'bein-sports-haber',
    type: 'channel',
    id: 'UCPe9vNjHF1kEExT5kHwc7aw',
    handle: 'beINSPORTSTürkiye',
    logoUrl:
      'https://yt3.googleusercontent.com/_vs7K9u3pS-C7flO0cVIkxqgLsIkjElGL6izCYFzI0COAYKda5g2J9DRB9-EHsfTXwA_ayi72g=s240-c-k-c0x00ffffff-no-rj',
    category: 'spor',
    color: C.purple,
  },
  {
    key: 'htspor',
    title: 'HT Spor',
    slug: 'htspor',
    type: 'channel',
    id: 'UCK3mI2lsk3LSo8PBUc8JTSw',
    handle: 'htspor',
    logoUrl:
      'https://yt3.googleusercontent.com/qm8gakzNZozT-LY8xbyAg3bZGAjMsiT4p9gD06mMLwl4rI4564dJp57uv4fVtyll3onIdeSFRHo=s240-c-k-c0x00ffffff-no-rj',
    category: 'spor',
    color: C.amber,
  },
  {
    key: 'ntvspor',
    title: 'NTV Spor',
    slug: 'ntvspor',
    type: 'channel',
    id: 'UCGMghpDmBAqhz2p7eLHX-eg',
    handle: 'NTVSpor',
    logoUrl:
      'https://yt3.googleusercontent.com/NLfEOQFazmlLR7z1zcz1HG4hFdpVooWodTQT6RQwStisP6cxQyO_EIVWhiCtgNyL1gaw3tbdTQ=s240-c-k-c0x00ffffff-no-rj',
    category: 'spor',
    color: C.red,
  },
  {
    key: 'sifir-tv',
    title: 'Sıfır TV',
    slug: 'sifir-tv',
    type: 'channel',
    id: 'UCDX7Vf8VLBHdC-HZtKG9gOQ',
    handle: 'sifirtv',
    logoUrl:
      'https://yt3.googleusercontent.com/uISpOU-Gdf_TWXZCyvQAFn_LeJhILd_84H30Fqpk4-fMTREWU4VsTOLAch4YBzSBxmoFxGPO=s240-c-k-c0x00ffffff-no-rj',
    category: 'spor',
    color: C.indigo,
  },
  {
    key: 'tay-tv',
    title: 'Tay TV',
    slug: 'tay-tv',
    type: 'channel',
    id: 'UCjkRA7KEdp7PDKDUs396XHg',
    handle: 'TayTvOfficial',
    logoUrl:
      'https://yt3.googleusercontent.com/YeXHd3MQCicG39ApxWUAjFupx41gtdXJKO9MQjzjZ4e87vxX46M_mufLeixgj5gm6g-z520N0w=s240-c-k-c0x00ffffff-no-rj',
    category: 'spor',
    color: C.green,
  },
  {
    key: 'tjk-tv',
    title: 'TJK TV',
    slug: 'tjk-tv',
    type: 'video',
    id: 'g89RQMJtK6E',
    logoUrl: 'https://i.ytimg.com/vi/g89RQMJtK6E/hqdefault.jpg',
    category: 'spor',
    color: C.green,
  },
  {
    key: 'trtspor',
    title: 'TRT Spor',
    slug: 'trtspor',
    type: 'channel',
    id: 'UCfYNqluOf8EbQkL44otydMw',
    handle: 'trtspor',
    logoUrl:
      'https://yt3.googleusercontent.com/FCzDc31AsTFzobw8Z4QBCc8AGtKgFP4mq28RgbcLJGdVNlE0RoremvEr1XntYHFc6G0dAwU-=s240-c-k-c0x00ffffff-no-rj',
    category: 'spor',
    color: C.blue,
  },
]

/** Eski slug → yeni slug (308) */
export const LIVE_TV_SLUG_ALIASES: Record<string, string> = {
  sozcutv: 'sozcu-tv',
  ulusalkanal: 'ulusal-kanal',
  tgrthaber: 'tgrt-haber',
  tgrteu: 'tgrt-haber',
  beinsports: 'bein-sports-haber',
  tjktv: 'tjk-tv',
  flashhaber: 'flash-haber',
  akittv: 'akit-tv',
  ulketv: 'ulke-tv',
  cnbce: 'cnbc-e',
  'tv-100': 'tv100',
  tv100haber: 'tv100',
  nowhaber: 'now-haber',
  'now-tv': 'now-haber',
  euronews: 'euronews-turkce',
  dwt: 'dw-turkce',
  'dw-turkish': 'dw-turkce',
  'ntv-spor': 'ntvspor',
  'trt-spor': 'trtspor',
  trtworld: 'trt-world',
}

export const LIVE_TV_CATEGORY_ORDER: LiveTvCategory[] = ['haber', 'spor']

export const LIVE_TV_CATEGORY_LABELS: Record<LiveTvCategory, string> = {
  haber: 'Haber',
  spor: 'Spor',
}

export function getLiveTvChannel(slug?: string | null): LiveTvChannel | null {
  if (!slug) return null
  const resolved = LIVE_TV_SLUG_ALIASES[slug] ?? slug
  return LIVE_TV_CHANNELS.find((c) => c.slug === resolved) ?? null
}

export function getLiveTvChannelsByCategory(category: LiveTvCategory) {
  return LIVE_TV_CHANNELS.filter((c) => c.category === category)
}

export function youtubeChannelLiveUrl(channel: LiveTvChannel) {
  if (channel.type === 'video') {
    return `https://www.youtube.com/watch?v=${channel.id}`
  }
  if (channel.handle) {
    return `https://www.youtube.com/@${encodeURIComponent(channel.handle)}/live`
  }
  return `https://www.youtube.com/channel/${channel.id}/live`
}

export function channelInitials(title: string) {
  const parts = title
    .replace(/TV|TÜRK|Türk|SPORTS|Spor|Haber/gi, '')
    .trim()
    .split(/\s+/)
    .filter(Boolean)
  if (parts.length >= 2) {
    return (parts[0]![0]! + parts[1]![0]!).toLocaleUpperCase('tr-TR')
  }
  return title.slice(0, 2).toLocaleUpperCase('tr-TR')
}
